import { defineElement, BaseElement } from '@webtides/element-js';
//dependencies
import '../../structures/_product/product-list/product-list';
import '../../../legacy-library/webcomponents/svg-icon/svg-icon';
import qs from 'qs/dist/qs';
import PagingElementEvents from '../../elements/paging-element/paging-element-events';
import SearchHistoryCookie from '../../../js/cookies/search-history';

class SearchPage extends BaseElement {
    properties() {
        return {
            products: [],
            productSearchUrl: '',
            total: 0,
            manualScroll: true,
            search: this.dataset.searchword || '',
            query: '',
            pageSize: 18,
            meta: {},
        };
    }

    async connected() {
        if (this.manualScroll && window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }

        if (this.products.length === 0) {
            await this.reloadProducts();
        }

        this.$refs.productList.products = this.products;
        //
    }

    watch() {
        return {
            products: () => {
                this.$refs.productList.products = this.products;
            },
            total: () => {
                this.querySelectorAll('product-count').forEach($productCount => {
                    $productCount.count = this.total;
                });
            },
        };
    }

    handleProductVisibility(loading = false) {
        this.classList.toggle('is-loading', loading);

        this.classList.toggle('is-empty', !loading && this.products.length === 0);

        if (this.$refs.paging && this.meta.paged) {
            this.$refs.paging.disabled = false;
            this.$refs.paging.pages = this.meta.pages;
            this.$refs.paging.currentPage = this.meta.page;
            this.$refs.paging.total = this.total;
        }
    }

    events() {
        return {
            this: {
                [PagingElementEvents.PAGE_CHANGE]: () => {
                    this.reloadProducts();
                },
            },
        };
    }

    fetch(url, options) {
        const fetchOptions = Object.assign(
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            },
            options
        );
        return fetch(url, fetchOptions)
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                //set undefined to trigger redraws
                return response;
            });
    }

    async reloadProducts() {
        const body = {
            text: this.search,
            pageSize: this.pageSize,
        };
        if (this.$refs.paging) {
            body.page = this.$refs.paging.currentPage;
        }
        this.handleProductVisibility(true);

        const query = qs.stringify(body, { arrayFormat: 'comma' });
        try {
            const { data, total, meta, paged } = await this.fetch(`${this.productSearchUrl}?${query}`);

            this.products = data || [];
            this.total = total;
            this.meta = { paged, ...meta } || {};
            this.handleProductVisibility();
            if (total > 0 && this.meta.page === 0 && this.search.length > 0) {
                // write history  cookie
                SearchHistoryCookie.add(this.search);
            }
            this.updateUrl(this.meta?.page ?? 0);
            this.dispatch('PRODUCTS_CHANGED', this.products, true);
        } catch (e) {
            console.log('could not load products', e);
            this.total = 0;
            this.handleProductVisibility();
        }
    }

    updateUrl(page = 0) {
        const searchParams = qs.parse(location.search?.substring(1) ?? '');

        if (parseInt(searchParams?.page ?? 0) !== page) {
            searchParams.page = page;
            this.query = qs.stringify(searchParams, { arrayFormat: 'comma' });
            history.replaceState(searchParams, '', `?${this.query}`);
        }
    }
}

defineElement('search-page', SearchPage);
